import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarCliente } from '../../actions/clientes';

const EliminarCliente = ({ cliente, reestablecerCliente }) => {

    const dispatch =  useDispatch();

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    /* Eliminar empresa */
    const handleProcesar = async () => {
        await setStatusProcesar(true);
        await dispatch(eliminarCliente(cliente?._id));
        await handleCerrar(null);
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            reestablecerCliente(null);
            setEliminarModal(false);
        }
    }

    useEffect(() => {
        if(cliente != null){
            setEliminarModal(true);
        }
    }, [cliente]);

    return (
        <Modal show={eliminarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar cliente</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas eliminar a {[cliente?.nombre, cliente?.apellido_paterno, cliente?.apellido_materno].join(' ')}?</p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> No</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Si</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EliminarCliente;